import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {convertDate, createDateTimeObjectFromDate, getGetHeaders} from '../shared/functions';
import {setDefaultTableSort, filterCaseInsensitive, getTableState} from '../shared/tableFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import ReactTable from 'react-table';
import {RESOURCES as searchResources} from '../fuseSearchResourceMap';
import EditButtonByCustomKey from '../buttons/EditButtonByCustomKey';
import ProductUnitsStaticIconButton from '../buttons/ProductUnitsStaticIconButton';
import TransferListProductsTable from './TransferListProductsTable';
import ViewButtonByCustomKey from '../buttons/ViewButtonByCustomKey';
import ViewButtonByLocationTransferId from '../buttons/ViewButtonByLocationTransferId';
import {tableStyles} from '../shared/styles-table';
import '../shared/react-table.css';

class TransferListByProductTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataComplete: false,
            dataList: [],
            dataTable: [],
            message: null
        };
        this.handleSortOrFilterChange = this.handleSortOrFilterChange.bind(this);
    }

    componentWillMount() {
        this.fetchData();
    }

    componentWillReceiveProps(nextProps) {
        const nextFilter = JSON.stringify(nextProps.filterValues);
        const thisFilter = JSON.stringify(this.props.filterValues);
        if (
            nextFilter !== thisFilter ||
            (!nextProps.listComplete && this.props.listComplete)
        ) {
            this.setState({
                dataComplete: false,
                dataList: [],
                dataTable: [],
                message: null
            });
        }
    }

    componentDidUpdate(prevProps) {
        const prevFilter = JSON.stringify(prevProps.filterValues);
        const thisFilter = JSON.stringify(this.props.filterValues);
        if (
            prevFilter !== thisFilter ||
            (prevProps.listComplete && !this.props.listComplete)
        ) {
            this.fetchData();
        }
    }

    /**
     * Get Transfers data containing specific Product term
     *
     */
    fetchData() {
        const filterValues = this.props.filterValues;
        let params = {
            filter: {
                condition: filterValues.receivedCondition,
                date_since: filterValues.startDate,
                path: 'itemNameLike',
                search_name: filterValues.searchName
            },
        };
        let conditionStr = '';
        if (filterValues.transferType !== 'any') {
            conditionStr = (filterValues.receivedCondition === 'received') ? 'Received ' : 'Incoming ';
        }
        let noneMessage;
        if (filterValues.transferType === 'repack') {
            params.filter.path = 'repackContentsLike';
            noneMessage = 'No ' + conditionStr + 'Repacks containing "' + filterValues.searchName + '" since ' + filterValues.startDateStr;
        } else if (filterValues.transferType === 'retailbox') {
            params.filter.path = 'retailContentsLike';
            noneMessage = 'No ' + conditionStr + 'Retail Boxes containing "' + filterValues.searchName + '" since ' + filterValues.startDateStr;
        } else {
            noneMessage = 'No ' + conditionStr + 'Transfers containing "' + filterValues.searchName + '" since ' + filterValues.startDateStr;
        }
        let resource = searchResources.TransferredProducts.GET_LIST(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            let list = [];
            if (result.error) {
                noneMessage = 'Sorry, there was an error retrieving Transfers.';
            } else if (result.data && result.data.payload) {
                list = result.data.payload;
            } else if (result.data && result.data.length > 0) {
                list = result.data;
            }
            this.processSearchData(list, noneMessage);
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
            } else if (error.request) {
                // No response
            } else {
            }
            this.processSearchData([], 'Sorry, there was an error retrieving Transfers.');
        });
    }

    /**
     * Process array of Incoming or Received Transfers, Repacks or Retail Boxes
     *
     * @param data
     * @param noneMessage
     */
    processSearchData(data, noneMessage) {
        let processedData = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let dateSent = convertDate(item.transfer_sent_time);
            let dateSentDate = createDateTimeObjectFromDate(item.transfer_sent_time);
            let dateReceived = (item.transfer_received_time) ? convertDate(item.transfer_received_time) : '';
            let dateReceivedDate = createDateTimeObjectFromDate(item.transfer_received_time);
            let dateRepack = (item.repack_modified) ? convertDate(item.repack_modified) : '';
            let dateRepackDate = createDateTimeObjectFromDate(item.repack_modified);
            let dateRetailBox = (item.retailbox_modified) ? convertDate(item.retailbox_modified) : '';
            let dateRetailBoxDate = createDateTimeObjectFromDate(item.retailbox_modified);

            // Create a Transfer, Repack or Retail Box row
            let result = {
                id: item.transfer_id,
                repack_contents: item.repack_contents,
                repack_id: item.repack_id,
                repack_modified: item.repack_modified,
                repack_modified_date: dateRepack,
                repack_modified_date_date: dateRepackDate,
                retailbox_contents: item.retailbox_contents,
                retailbox_id: item.retailbox_id,
                retailbox_modified: item.retailbox_modified,
                retailbox_modified_date: dateRetailBox,
                retailbox_modified_date_date: dateRetailBoxDate,
                transfer_contents: [],
                transfer_id: item.transfer_id,
                transfer_location_from: item.transfer_location_from,
                transfer_location_to: item.transfer_location_to,
                transfer_product_barcode: item.transfer_product_barcode,
                transfer_product_id: item.transfer_product_id,
                transfer_product_name: item.transfer_product_name,
                transfer_product_unit_type: item.transfer_product_unit_type,
                transfer_product_uuid: item.transfer_product_uuid,
                transfer_qty_of_units: item.transfer_qty_of_units,
                transfer_received: item.transfer_received,
                transfer_received_date: dateReceived,
                transfer_received_date_date: dateReceivedDate,
                transfer_received_time: (item.transfer_received_time) ? item.transfer_received_time : 'N/A',
                transfer_sent_date: dateSent,
                transfer_sent_date_date: dateSentDate,
                transfer_sent_time: item.transfer_sent_time,
                transfer_unit_piece_qty: item.transfer_unit_piece_qty
            };

            // Consolidate Transfers
            if (this.props.filterValues.transferType === 'any') {
                const tIdx = processedData.findIndex(r => r.transfer_id === item.transfer_id);
                if (tIdx !== -1) {
                    // Update the existing Transfer row
                    processedData[tIdx].transfer_contents.push({
                        barcode: item.transfer_product_barcode,
                        product_name: item.transfer_product_name,
                        unit_qty: item.transfer_unit_piece_qty,
                        unit_type: item.transfer_product_unit_type
                    });

                } else {
                    // Add a new Transfer row with its initial Product
                    result.transfer_contents.push({
                        barcode: result.transfer_product_barcode,
                        product_name: result.transfer_product_name,
                        unit_qty: result.transfer_unit_piece_qty,
                        unit_type: result.transfer_product_unit_type
                    });
                    processedData.push(result);
                }
            } else {
                // Add a new row
                processedData.push(result);
            }
        }
        let message = (processedData.length === 0) ? noneMessage : null;
        this.storeProcessedData(processedData, message);
    }

    /**
     * Store data from processing and lift state
     *
     * @param data
     * @param message
     */
    storeProcessedData(data, message = null) {
        this.setState({
            dataComplete: true,
            dataList: data,
            dataTable: data,
            message: message
        }, () => {
            if (typeof this.props.onDataComplete === 'function') {
                this.props.onDataComplete(true);
            }
        });
    }

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortOrFilterChange(event, table) {
        const tableData = getTableState(table);
        if (tableData && tableData.length > 0) {
            this.setState({
                dataTable: tableData
            });
        }
    }

    /**
     * Render a table subcomponent with a result's Products
     *
     * @param row
     * @returns {JSX.Element}
     */
    listSubcomponent = (row) => {
        let list = [];
        let type = 'any';
        if (row.original.transfer_contents && row.original.transfer_contents.length > 0) {
            list = row.original.transfer_contents;
            type = 'any';
        }
        if (row.original.repack_contents && row.original.repack_contents.length > 0) {
            list = row.original.repack_contents;
            type = 'repack';
        }
        if (row.original.retailbox_contents && row.original.retailbox_contents.length > 0) {
            list = row.original.retailbox_contents;
            type = 'retailbox';
        }
        let searchTerm = (this.props.filterValues && this.props.filterValues.searchName) ? this.props.filterValues.searchName : '';

        return (
            <TransferListProductsTable type={type} list={list} searchTerm={searchTerm}/>
        );
    };

    render() {
        const {
            basePathCollections,
            basePathTransfers,
            filterValues
        } = this.props;

        const {
            dataComplete,
            dataList,
            message
        } = this.state;

        const defaultSort = setDefaultTableSort({field: 'transfer_sent_time', order: 'ASC'});

        const tableColumns = [];
        if (filterValues.transferType === 'any') {
            tableColumns.push(
                {
                    Header: '',
                    accessor: 'transfer_sent_date',
                    style: tableStyles.hide,
                    headerStyle: tableStyles.hide
                },
                {
                    Header: 'Sent',
                    accessor: 'transfer_sent_date_date',
                    Cell: row => (
                        <span>{row.original.transfer_sent_date}</span>
                    ),
                    width: 180,
                    headerStyle: tableStyles.left
                },
                {
                    Header: 'Transfer ID',
                    accessor: 'transfer_id',
                    width: 180,
                    headerStyle: tableStyles.left
                },
                {
                    Header: () => (<span>From<br/>Location</span>),
                    accessor: 'transfer_location_from',
                    width: 100,
                    headerStyle: tableStyles.left
                },
                {
                    Header: () => (<span>To<br/>Location</span>),
                    accessor: 'transfer_location_to',
                    width: 100,
                    headerStyle: tableStyles.left
                }
            );
        }
        if (filterValues.transferType === 'repack') {
            tableColumns.push(
                {
                    Header: '',
                    accessor: 'repack_modified_date',
                    width: 180,
                    style: tableStyles.hide,
                    headerStyle: tableStyles.hide
                },
                {
                    Header: 'Created',
                    accessor: 'repack_modified_date_date',
                    Cell: row => (
                        <span>{row.original.repack_modified_date}</span>
                    ),
                    width: 180,
                    headerStyle: tableStyles.left
                },
                {
                    Header: 'Collection ID',
                    accessor: 'repack_id',
                    headerStyle: tableStyles.left
                }
            );
        }
        if (filterValues.transferType === 'retailbox') {
            tableColumns.push(
                {
                    Header: '',
                    accessor: 'retailbox_modified_date',
                    width: 180,
                    style: tableStyles.hide,
                    headerStyle: tableStyles.hide
                },
                {
                    Header: 'Created',
                    accessor: 'retailbox_modified_date_date',
                    Cell: row => (
                        <span>{row.original.retailbox_modified_date}</span>
                    ),
                    width: 180,
                    headerStyle: tableStyles.left
                },
                {
                    Header: 'Collection ID',
                    accessor: 'retailbox_id',
                    headerStyle: tableStyles.left
                }
            );
        }
        if (filterValues.receivedCondition === 'any') {
            tableColumns.push(
                {
                    Header: 'Received',
                    accessor: 'transfer_received',
                    Cell: row => (
                        <span>{(row.original.transfer_received) ? 'Yes' : 'No'}</span>
                    ),
                    width: 80,
                    headerStyle: tableStyles.left
                }
            );
        }
        tableColumns.push(
            {
                Header: 'Products',
                source: '',
                label: '',
                Expander: ({isExpanded}) =>
                    <div>
                        {isExpanded
                            ? <ProductUnitsStaticIconButton/>
                            : <ProductUnitsStaticIconButton/>}
                    </div>,
                expander: true,
                filterable: false,
                sortable: false,
                width: 90
            }
        );
        if (filterValues.transferType === 'any') {
            tableColumns.push(
                {
                    Header: '',
                    accessor: 'id',
                    filterable: false,
                    sortable: false,
                    Cell: row => (
                        <ViewButtonByLocationTransferId
                            basePath={basePathTransfers}
                            record={{
                                location_from: row.original.transfer_location_from,
                                location_to: row.original.transfer_location_to,
                                transfer_id: row.original.transfer_id,
                                transfer_type: (row.original.transfer_received) ? 'received' : 'incoming'
                            }}
                        />
                    ),
                    width: 80,
                    styles: {...tableStyles.right, ...tableStyles.noPadding}
                }
            );
        }
        if (filterValues.transferType === 'repack' || filterValues.transferType === 'retailbox') {
            tableColumns.push(
                {
                    Header: '',
                    id: (filterValues.transferType === 'repack') ? 'repack_id_view' : 'retailbox_id_view',
                    filterable: false,
                    sortable: false,
                    Cell: row => (
                        <ViewButtonByCustomKey
                            basePath={basePathCollections}
                            customKey={(filterValues.transferType === 'repack') ? 'repack_id' : 'retailbox_id'}
                            record={{
                                repack_id: row.original.repack_id,
                                retailbox_id: row.original.retailbox_id
                            }}
                        />
                    ),
                    width: 80,
                    styles: {...tableStyles.right, ...tableStyles.noPadding}
                },
                {
                    Header: '',
                    id: (filterValues.transferType === 'repack') ? 'repack_id_edit' : 'retailbox_id_edit',
                    filterable: false,
                    sortable: false,
                    Cell: row => (
                        <EditButtonByCustomKey
                            basePath={basePathCollections}
                            customKey={(filterValues.transferType === 'repack') ? 'repack_id' : 'retailbox_id'}
                            record={{
                                repack_id: row.original.repack_id,
                                retailbox_id: row.original.retailbox_id
                            }}
                        />
                    ),
                    width: 80,
                    styles: {...tableStyles.right, ...tableStyles.noPadding}
                }
            );
        }

        return (
            <div>
                {dataComplete && dataList.length > 0 &&
                    <div className="list-table-container">
                        <ReactTable
                            key="table-incoming-transfers-list"
                            data={dataList}
                            columns={tableColumns}
                            defaultPageSize={20}
                            showPagination={true}
                            defaultSorted={defaultSort}
                            filterable
                            defaultFilterMethod={filterCaseInsensitive}
                            onSortedChange={(e) => this.handleSortOrFilterChange(e, this.transfersReactTable)}
                            onFilteredChange={(e) => this.handleSortOrFilterChange(e, this.transfersReactTable)}
                            ref={(r) => this.transfersReactTable = r}
                            resizable={false}
                            minRows={1}
                            SubComponent={this.listSubcomponent}
                        />
                    </div>
                }
                {dataComplete && message &&
                    <p>{message}</p>
                }
            </div>
        );
    }
}

TransferListByProductTable.propTypes = {
    basePathCollections: PropTypes.string,
    basePathTransfers: PropTypes.string,
    filterValues: PropTypes.object,
    listComplete: PropTypes.bool,
    onDataComplete: PropTypes.func,
    system: PropTypes.string,
};

TransferListByProductTable.defaultProps = {
    filterValues: {
        receivedCondition: '',
        searchName: '',
        startDate: null,
        startDateStr: '',
        transferType: ''
    },
    listComplete: false
};

export default TransferListByProductTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/TransferListByProductTable.js